import '../styles/globals.scss';
import type { AppProps } from 'next/app'
import { PaymentProvider } from "../store/PaymentContext";
import { AppContextProvider } from "../store/AppContext";
import ToasterProvider from '../components/Toast';
import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { pageview, GTM_TRACKING_ID } from '../utils/gtag';

export default function App({ Component, pageProps }: AppProps)  {

  const router = useRouter();
  // const SEO = {
  //   ...(pageProps.seo != null ? { ...pageProps.seo } : {}),
  //   defaultTitle: "Hoài Giang shop - Chuyên may, bán và cho thuê trang phục",
  // };




  // useEffect(() => {
  //   if (window.location.pathname !== "/") {
  //     router.push(window.location.pathname + window.location.search);
  //   }

  // }, []);

  // useEffect(() => {
  //   const handleStart = (url: any) => (url !== router.pathname) && setLoading(true);
  //   const handleComplete = (url: any) => (url === router.pathname) && setLoading(false);
  //   const handleError = (url: any) => setLoading(false);
  //   router.events.on('routeChangeStart', handleStart)
  //   router.events.on('routeChangeComplete', handleError)
  //   router.events.on('routeChangeError', handleError)

  //   return () => {
  //     router.events.off('routeChangeStart', handleStart)
  //     router.events.off('routeChangeComplete', handleError)
  //     router.events.off('routeChangeError', handleError)
  //   }
  // });

  useEffect(() => {
     setTimeout(function(){
        var noscript = document.createElement('noscript')
        var iframe = document.createElement('iframe')
        iframe.setAttribute("id", `${GTM_TRACKING_ID}`)
        iframe.setAttribute('src', `https://www.googletagmanager.com/ns.html?id=${GTM_TRACKING_ID}`)
        iframe.setAttribute("height", "0")
        iframe.setAttribute("width", "0")
        iframe.setAttribute("style", "display:none;visibility:hidden")
        noscript.appendChild(iframe);
        var legendSc = document.getElementById(`${GTM_TRACKING_ID}`);
        if (!legendSc) {
          document.body.appendChild(noscript)
        }
      }, 3500);
  }, [])

  useEffect(() => {
    if (router.asPath.indexOf('[...slug]') <= 0)
      pageview(process.env.SITE_URL?.slice(0, -1) + router.asPath)
  }, [router.asPath])

  // useEffect(() => {

  //   const handleRouteChange = () => {
  //     pageview(router.asPath);

  //   }
  //   handleRouteChange();
  //   // router.events.on('routeChangeComplete', handleRouteChange)
  //   // return () => {
  //   //   router.events.off('routeChangeComplete', handleRouteChange)
  //   // }
  // }, [router])

  //console.log("loading start", loading);

  // const callSeo = async () => {
  //   let url = router.asPath.slice(0, router.asPath.length - 1) ?? "/"
  //   if (url.indexOf("page") > -1) {
  //     url = url.slice(0, url.indexOf("?") - 1);
  //   }
  //   const urlInput = router.asPath.slice(0, router.asPath.length - 1) ?? "/"
  //   const type = await getTypeUrl(url);
  //   //await setTypeData(type);
  //   if (urlInput === "") {
  //     let res = await getPageSEO("/" + "&type=2");
  //     res.keyword = res.keyword?.map((item: any) => item.keyword);
  //     await setSeo(res);

  //   } else {
  //     if (type !== null) {
  //       let res = await getPageSEO(urlInput + "&type=" + type);
  //       await setSeo(res);

  //     }
  //   }
  // }

  return (
    <AppContextProvider>
      <PaymentProvider>
        {/* <DefaultSeo {...SEO} /> */}
        {/* <DynamicGoogleAnalytic /> */}
        <Component {...pageProps} />
        <ToasterProvider />
        {/* <LoadingComponent loading={false} /> */}
      </PaymentProvider>
    </AppContextProvider>
  )
}

